import BaseRepository from "./BaseRepository";
import { STRIPE_KEY } from "config/globals";

export default new (class StripeRepository extends BaseRepository {
  createAccount() {
    return this.api.post(`/integrations/stripe/company_account`);
  }
  registerCompany() {
    return this.api.post(`/integrations/stripe/company_account/registration`);
  }
  confirmRegistration(code) {
    return this.api.put(`integrations/stripe/company_account/confirmation`, {
      code,
    });
  }
  getStripe() {
    return this.api.get(`/integrations/stripe/company_account`);
  }
  getStripeLogin() {
    return this.api.get(`/integrations/stripe/company_account/login`);
  }
  expressRegistration() {
    return this.api.post(`/integrations/stripe/express_registration`);
  }
  paymentOperations(order_id, order_token, order, timeout) {
    timeout = timeout || 2000;
    setTimeout(() => {
      const c_id = st.authorize.company.id;
      const callbackUrl = `${window.location.origin}/c/${c_id}/orders/${order_id}/${order_token}`;
      const call = this.api
        .post(`/payment_operations`, {
          order_id,
          order_token,
          source_type: "stripe",
          success_url: callbackUrl,
          cancel_url: callbackUrl,
        })
        .subscribe(window.afterStripe, call);
    }, timeout);
  }
})();

window.afterStripe = function (data) {
  const stripe = window.Stripe(STRIPE_KEY);

  stripe
    .redirectToCheckout({
      sessionId: data.data.session_id || "",
    })
    .then(function (result) {
      console.log(result);
    });
};



// WEBPACK FOOTER //
// ./src/lib/repositories/StripeRepository.js